module.exports = __webpack_public_path__ + "static/media/TextAnalysis.a8e7d637.svg";